<template>
    <v-container style="height: 100vh" class="d-flex align-center">
        <v-row>
            <v-col cols="12" class="d-flex justify-center mb-5">
                <img
                    src="/img/bobbee_logo_3.png"
                    :height="!$vuetify.display.mobile ? '100vh' : ''"
                    :width="!$vuetify.display.mobile ? '' : '200vw'"
                />
            </v-col>
            <v-col cols="12" class="d-flex justify-center display-2">
                Erreur : Droits d'accès insuffisants !
            </v-col>
            <v-col cols="12" class="d-flex justify-center mt-5">
                <v-btn @click="redirect">Retour</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class NoAccessPage extends Vue {
    async getRedirectName(): Promise<string> {
        const user = this.$store.state.user;
        if (!user || !user.profile || !user.profile.configuration) {
            return "login";
        }

        const config = user.profile.configuration;

        if (user.profile.homePage) {
            return user.profile.homePage;
        }

        if (config.business?.dashboard) {
            return "dashboard";
        }

        if (config.document?.read) {
            return "documents";
        }

        if (config.accounting?.dashboard) {
            return "dashboardAccounting";
        }

        if (config.stock?.read) {
            return "stocks";
        }

        if (config.task?.read) {
            return "tasks";
        }

        if (config.bankTransaction?.read) {
            return "bank";
        }

        if (config.chat?.read) {
            return "chat";
        }

        return "home";
    }

    async redirect() {
        const redirectName = await this.getRedirectName();
        this.$router.push({ name: redirectName });
    }
}

export default toNative(NoAccessPage);
</script>
